// extracted by mini-css-extract-plugin
module.exports = {"root":"icon_root__3cSDn","gray":"icon_gray__2EZ3l","success":"icon_success__2HeFa","danger":"icon_danger__17ekz","dark":"icon_dark__2Ooe0","brand":"icon_brand__3gqJw"};